import React from "react";
import "../../container.css";

export default function AnnouncementPulse({ imageHeight }) {
  return (
    <div className="rounded shadow animate-pulse">
      <div className={`object-fill w-full bg-gray-200 ${imageHeight}`}></div>
      <div className="mx-5">
        <div className="p-2 accouncement_desc">
          <div className="text-yellow-400 text-xs bg-gray-200 h-2"></div>
          <div className="font-bold bg-gray-200 h-2"></div>
          <div className="text-gray-400 text-xs bg-gray-200 h-5"></div>
        </div>
      </div>
    </div>
  );
}
